module.exports = __webpack_public_path__ + "img/0Q3B3332_P_T_L_Black_MockedUp.0a761d90.jpg";